import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';

import { Diet } from 'src/app/interfaces/diet';
import { DietService } from 'src/app/services/diet.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

dayjs.extend(utc);
@Component({
  selector: 'app-mobile-own-diet',
  templateUrl: './mobile-own-diet.component.html',
  styleUrls: ['./mobile-own-diet.component.scss'],
})
export class MobileOwnDietComponent implements OnInit {
  diet?: Diet;
  dietId?: string;
  userId?: number;

  constructor(
    private route: ActivatedRoute,
    private storageService: StorageService,
    private dietService: DietService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['token']) {
        // Save token to localStorage
        this.storageService.set('accessToken', params['token']);

        this.userId = this.decodeJwt(params['token']).sub;

        this.getUserDietHistory();
      }

      if (params['dietId']) {
        this.dietId = params['dietId'];
      }
    });
  }

  getUserDietHistory() {
    if (!this.userId) return;
    this.dietService.getUserDietHistory(String(this.userId)).subscribe({
      next: (response: any) => {
        if (!response.diets) return;

        response.diets.forEach((diet: Diet) => {
          diet.parsedFinishAt = dayjs(diet.finishedAt)
            .utc()
            .format('DD/MM/YYYY');

          diet.parsedStartAt = dayjs(diet.startAt).utc().format('YYYY-MM-DD');
        });

        this.diet = response.diets.filter(
          (d: Diet) => d.id == parseInt(this.dietId!)
        )[0];
      },
      error: (_error) => {
        this.toastService.alert(
          'Ha ocurrido un problema encontrando las dietas en la base de datos.'
        );
      },
    });
  }

  private decodeJwt(token: string): any {
    try {
      // JWT is made of three parts: header, payload, and signature
      // We only need the payload (second part)
      const base64Payload = token.split('.')[1];
      const base64 = base64Payload.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return null;
    }
  }
}
